import { gql } from "@apollo/client"

export const DELETE_VOUCHER = gql`
  mutation($storeId: String!, $voucherId: String!) {
    deleteVoucher(restaurantId: $storeId, id: $voucherId)
  }
`
